export const LOOKUP_LOCALE_ZHCHS = {
    placeholder: 'è¯·éæ©',
    favorites: 'æ¶èå¤¹',
    selected: 'å·²éæ°æ®',
    okText: 'ç¡®å®',
    cancelText: 'åæ¶',
    allColumns: 'ææå',
    datalist: 'æ°æ®åè¡¨',
    mustWriteSomething: 'è¯·è¾å¥å³é®å­åæ¥è¯¢ã',
    mustChoosAdatarow: 'è¯·éæ©ä¸æ¡è®°å½ï¼',
    tipText: 'æ¨è¦æ¾çæ¯ä¸æ¯è¿äºï¼',
    cascade: {
        enable: 'åæ­¥éæ©',
        disable: 'ä»éæ©èªèº«',
        up: 'åå«ä¸çº§',
        down: 'åå«ä¸çº§'
    },
    favoriteInfo: {
        addFav: 'æ¶èæåã',
        cancelFav: 'åæ¶æ¶èæåã '
    },
    getAllChilds: 'è·åææå­çº§æ°æ®',
    contextMenu: {
        expandall: 'å¨é¨å±å¼',
        collapseall: 'å¨é¨æ¶èµ·',
        expandByLayer: 'æå±çº§å±å¼',
        expand1: 'å±å¼ 1 çº§',
        expand2: 'å±å¼ 2 çº§',
        expand3: 'å±å¼ 3 çº§',
        expand4: 'å±å¼ 4 çº§',
        expand5: 'å±å¼ 5 çº§',
        expand6: 'å±å¼ 6 çº§',
        expand7: 'å±å¼ 7 çº§',
        expand8: 'å±å¼ 8 çº§',
        expand9: 'å±å¼ 9 çº§'
    },
    quick: {
        notfind: 'æªæ¾å°æç´¢åå®¹',
        more: 'æ¾ç¤ºæ´å¤'
    },
    configError: 'å¸®å©æ¾ç¤ºåæªéç½®ï¼è¯·æ£æ¥æ¯å¦å·²æ­£ç¡®éç½®å¸®å©æ°æ®æº! ',
    selectedInfo: {
        total: 'å·²é <span class="selected-counter mx-1">{0}</span> æ¡',
        clear: 'åæ¶å·²é',
        remove: 'ç§»é¤ ({0})',
        confirm: 'æ¨ç¡®è®¤è¦åæ¶ææéä¸­è®°å½å?'
    },
    clearAllConditions: 'æ¸é¤æææ¥è¯¢æ¡ä»¶',
    anyFields: 'å¨é¨'
};
